import React from 'react'
import { Row, Col } from 'react-bootstrap'

export default ({text}) => {
  return (
    <Row>
      <Col className="font-weight-bold">
        {text}
      </Col>
    </Row>
  )
}
